export enum DropdownType {
  DEFAULT = 'default',
  COMBOBOX = 'combobox',
  COMBOBOX_FILTER = 'combobox-filter',
}
